import type {RequestOptions} from '@@/plugin-request/request';
import type {RequestConfig} from '@umijs/max';
import {message} from 'antd';

// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data?: any;
  error_message?: string;
}

export const errorConfig: RequestConfig = {
  // 错误处理：umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      const {success, data, error_message} =
        res as unknown as ResponseStructure;
      if (!success) {
        const error: any = new Error(error_message);
        error.name = 'BizError';
        error.info = {error_message, data};
        throw error; // 抛出自制的错误
      }
    },
    // 错误接收及处理
    errorHandler: async (error: any) => {
      const {response, config} = error;
      
      // 不需要重定向的登录页面路径
      const loginPaths = ['/user/login', '/user/wecom-login', '/user/sso-login'];
      // 检查当前是否在登录页面
      const isLoginPage = loginPaths.some(path => 
        window.location.pathname === path || window.location.pathname.startsWith(path + '/')
      );
      
      if (response && response.status === 401 && !isLoginPage) {
        message.error('登录已过期，请重新登录');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        // 重定向至登录页
        let login_method = localStorage.getItem('login_method');
        if (login_method === 'web') {
          window.location.href = '/user/login';
        } else if (login_method === 'sso') {
          window.location.href = '/user/sso-login';
        } else if (login_method === 'wecom') {
          window.location.href = '/user/wecom-login';
        } else {
          window.location.href = '/user/wecom-login';
          localStorage.setItem('login_method', 'wecom');
        }
      } else if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        message.error(`请求失败，状态码：${error.response.status}`);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        message.error('无响应，请检查网络连接');
      } else {
        // 发送请求时出了点问题
        message.error('请求错误，请重试');
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    // 请求附加 JWT
    (config: RequestOptions) => {
      const access_token = localStorage.getItem('access_token');
      if (access_token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${access_token}`,
        };
      }
      return config;
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const {data} = response as unknown as ResponseStructure;

      if (data?.success === false) {
        message.error('请求失败！');
      }
      return response;
    },
  ],
};
